import { render, staticRenderFns } from "./select-goods.vue?vue&type=template&id=35d91d23&scoped=true"
import script from "./select-goods.vue?vue&type=script&lang=js"
export * from "./select-goods.vue?vue&type=script&lang=js"
import style0 from "./select-goods.vue?vue&type=style&index=0&id=35d91d23&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d91d23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35d91d23')) {
      api.createRecord('35d91d23', component.options)
    } else {
      api.reload('35d91d23', component.options)
    }
    module.hot.accept("./select-goods.vue?vue&type=template&id=35d91d23&scoped=true", function () {
      api.rerender('35d91d23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliancecso/contractManager/dialog/select-goods.vue"
export default component.exports